import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import './NewsItem.css';

class NewsItem extends Component {
  render() {
    return (

      <Fade delay={200}>
        <div className="news-item">
          <Link to={{
            pathname: '/news/' + this.props.path,
            state: {
              next: this.props.next,
              previous: this.props.previous,
            },
          }}
          >
            <div className="image" style={{ backgroundImage: `url(${this.props.image})` }} />

            <div className="title">
              {this.props.title}
            </div>

            <div className="content">
              {this.props.content}
            </div>
          </Link>
        </div>
      </Fade>


    );
  }
}

export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/common/NewsItem.js